import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, Validators } from "@angular/forms";
import { V3ServicesService } from "src/app/core/services/v3-services.service";
import { ToastrService } from "ngx-toastr";
import { ProductV2Service } from "src/app/core/services/product-v2.service";

@Component({
  selector: "app-header-menu",
  templateUrl: "./header-menu.component.html",
  styleUrls: ["./header-menu.component.scss"],
})
export class HeaderMenuComponent {
  serviceForm: FormGroup;
  hasChanges = false;
  isSubmitted = false;

  isUpdating = false;
  deletedService = [];
  sources = [];
  constructor(
    private fb: FormBuilder,
    private apiv2: ProductV2Service,
    private toastr: ToastrService,
    private api: V3ServicesService
  ) {}

  ngOnInit(): void {
    this.resetForm();
    this.getHeaderServices();
    this.getSources();
  }

  resetForm() {
    this.serviceForm = this.fb.group({
      services: this.fb.array([]),
    });
  }
  getSources() {
    this.apiv2.getWhitelabelSources().subscribe((response: any) => {
      this.sources = response;
    });
  }

  getHeaderServices() {
    this.api.getHeaderServices().subscribe((result: any) => {
      this.setData(result);
    });
  }

  setData(result) {
    this.serviceForm = this.fb.group({
      services: new FormArray([]),
    });
    result.forEach((ao) => {
      (this.serviceForm.get("services") as FormArray).push(
        this.fb.group({
          id: [ao.id],
          name: [ao.name, [Validators.required]],
          router: [ao.router, [Validators.required]],
          is_external: [ao.is_external ?? false],
          is_updated: [false],
          is_new: [false],
          sources: [ao?.sources, Validators.required],
        })
      );
    });
  }

  service(): FormArray {
    return this.serviceForm.get("services") as FormArray;
  }

  newservice(): FormGroup {
    return this.fb.group({
      name: ["", [Validators.required]],
      router: ["", [Validators.required]],
      is_external: [false],
      is_updated: [false],
      is_new: [true],
      sources:['',Validators.required]
    });
  }

  addservice() {
    this.service().push(this.newservice());
  }

  removeservice(i: number) {
    this.isSubmitted = false;
    this.serviceForm.value.services[i].is_deleted = true;
    if (this.serviceForm.value.services[i].hasOwnProperty("id"))
      this.deletedService.push(this.serviceForm.value.services[i]);
    this.service().removeAt(i);
  }

  dataChanged(i) {
    let ae = this.serviceForm.value.services[i];
    if (ae.is_new) {
      delete ae.is_updated;
    } else {
      ae.is_updated = true;
      delete ae.is_new;
    }
  }

  onSubmit(form) {
    if (form.valid) {
      this.isUpdating = true;
      this.deletedService.forEach((ae) => {
        delete ae.is_updated;
        delete ae.is_new;
        form.value.services.push(ae);
      });

      this.api.setHeaderService(form.value.services).subscribe(
        () => {
          this.toastr.success("Content Updated Successfully!");
          this.getHeaderServices();
          this.hasChanges = false;
          this.isUpdating = false;
        },
        () => {
          this.isUpdating = false;
        }
      );
    }
  }
}
